import './App.css';
import {Nav} from "./components/Nav"
import {Home} from "./components/Home"
import { Verify } from './components/Verify';
import { FindTrusted } from './components/FindTrusted';
import { OurFeature } from './components/OurFeature';
import { Discover } from './components/Discover';
import { OurBlog } from './components/OurBlog';
import { RealWeding } from './components/RealWeding';
import { BestOffer } from './components/BestOffer';
import { Testimonial } from './components/Testimonial';
import { UserChoice } from './components/UserChoice';
import { OurSuccess } from './components/OurSuccess';
import { Ultimatecourse } from './components/Ultimatecourse';
import { Grow } from './components/Grow';
import { NeverMiss } from './components/NeverMiss';
const App=()=> {
  return (
    <div className="App">
     <Nav/>
     <Home/>
     <Verify/>
     <FindTrusted/>
     <OurFeature/>
     <Discover/>
     <OurBlog/>
     <RealWeding/>
     <BestOffer/>
     <Testimonial/>
     <UserChoice/>
     <OurSuccess/>
     <Ultimatecourse/>
     <Grow/>
     <NeverMiss/>
    </div>
  );
}

export default App;
